import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    background: '#fff',
    borderTop: '1px solid rgb(205, 205, 205)'
  },
  content: {
    width: '920px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  textContainer: {
    flex: 1,
    textAlign: 'center',
    color: 'rgb(74, 74, 74)',
    fontSize: '16px',
    lineHeight: '18px'
  },
  saveNowButtonRoot: {
    color: 'rgb(74, 74, 74)',
    fontSize: '16px !important',
    lineHeight: '18px !important',
    fontFamily: 'SofiaPro !important',
    fontWeight: 400,
    textDecoration: 'underline'
  }
}))
